/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.activities.activities'},
});

const ActivitiesItem = () => (
  <RouteLinkItem
    route="midas/settings/activities/activities"
    title={messages.title}
  />
);

export default ActivitiesItem;
